import React from 'react';
import AccurityDatePicker from '../../../dateField/components/AccurityDatePicker';
import { useComparisonFilter } from './useComparisonFilter';
import AccurityIconButton from '../../../buttons/components/AccurityIconButton';
var DateFilter = function (_a) {
    var dateColumn = _a.dateColumn, onFilterChange = _a.onFilterChange;
    var _b = useComparisonFilter(dateColumn, onFilterChange), comparisonSelectorComponent = _b[0], filterValue = _b[1], onFilterValueChange = _b[2];
    var onDateChange = function (newDateValue) {
        if (typeof newDateValue === 'number' && isNaN(newDateValue)) {
            return; // Do not update filter with invalid Date, let User keep typing to create valid Date
        }
        onFilterValueChange(newDateValue);
    };
    var clearIcon = !filterValue ? null :
        React.createElement(AccurityIconButton, { onClick: function () { return onFilterValueChange(undefined); }, name: "date-filter", iconName: "mui:Close", size: "small" });
    return (React.createElement("div", { className: "columnFilter columnFilter--withComparisonSelector dateFilter" },
        comparisonSelectorComponent,
        React.createElement("div", { className: "dateFilter__datePicker" },
            React.createElement(AccurityDatePicker, { value: Number(filterValue), onChange: onDateChange, inputEndAdornment: clearIcon, disabled: !dateColumn.filterable }))));
};
export default DateFilter;
//# sourceMappingURL=DateFilter.js.map